
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0031"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0031"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $hNeh9 = parcelRequire("hNeh9");

var $800sp = parcelRequire("800sp");
/**
 * Represents a Last-In, First-Out (LIFO) stack.
 * 
 * @template T The type of elements held in the stack.
 */ class $ceb960a0a14a1b97$export$694e0d28c7ffc90c {
    /**
     * The array holding the stack items.
     * @type {Array<T>}
     */ items;
    /**
     * The array holding the stack items.
     * @param  {Array<T>} items
     */ constructor(items = []){
        this.items = items;
    }
    /**
     * Adds an item to the top of the stack.
     * @param {T} item The item to add.
     * @returns {number} The new length of the stack.
     */ push(item) {
        return this.items.unshift(item);
    }
    /**
     * Removes and returns the item from the top of the stack.
     * @returns {T | undefined} The removed item, or undefined if the stack is empty.
     */ pop() {
        return this.items.shift();
    }
    /**
     * Returns the item at the top of the stack without removing it.
     * @returns {T | undefined} The top item, or undefined if the stack is empty.
     */ peek() {
        return this.items[0];
    }
    /**
     * Returns a copy of all elements in the stack as an array,
     * ordered from top (most recent) to bottom (least recent).
     * This method does not modify the original stack.
     * @returns {Array<T>} An array containing all elements, with the most recently added element at index 0.
     */ get elements() {
        // Create a reversed copy to avoid mutating the internal 'items' array
        //return this.items.toReversed()
        return this.items;
    }
    /**
     * Checks if the stack is empty.
     * @returns {boolean} True if the stack is empty, false otherwise.
     */ isEmpty() {
        return this.items.length === 0;
    }
    /**
     * Gets the number of items in the stack.
     * @returns {number} The size of the stack.
     */ get size() {
        return this.items.length;
    }
    /**
     * Clears all items from the stack.
     */ clear() {
        this.items = [];
    }
}



var $8uVid = parcelRequire("8uVid");
const $c06cac3eedeb74d1$var$_LOG = (0, $8uVid.debug)({
    on: true,
    topic: 'LG4JResult'
});
const $c06cac3eedeb74d1$var$_DBG = (0, $8uVid.debug)({
    on: false,
    topic: 'LG4JResult'
});
class $c06cac3eedeb74d1$export$c5542a7edb16317 extends (0, $800sp.LitElement) {
    static styles = [
        (0, $hNeh9.default),
        (0, $800sp.css)`
  json-viewer {
    --font-size: .8rem;
  }`
    ];
    static properties = {};
    /**
   * @type {Map<string, Stack<ResultData[]>>}
   */ threadMap = new Map();
    /** 
   * @type {string|undefined}
   */ #selectedThread;
    get selectedTab() {
        return this.#selectedThread;
    }
    set selectedTab(thread) {
        this.#selectedThread = thread;
        this.dispatchEvent(new CustomEvent('thread-updated', {
            detail: thread,
            bubbles: true,
            composed: true,
            cancelable: true
        }));
    }
    constructor(){
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        // @ts-ignore
        this.addEventListener('result', this.#onResult);
        // @ts-ignore
        this.addEventListener('init-threads', this.#onInitThreads);
        // @ts-ignore
        this.addEventListener('node-updated', this.#onNodeUpdated);
        // @ts-ignore
        this.addEventListener('state-updated', this.#onStateUpdated);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // @ts-ignore
        this.removeEventListener('state-updated', this.#onStateUpdated);
        // @ts-ignore
        this.removeEventListener('result', this.#onResult);
        // @ts-ignore
        this.removeEventListener('init-threads', this.#onInitThreads);
        // @ts-ignore
        this.removeEventListener('node-updated', this.#onNodeUpdated);
    }
    /**
   * Event handler for the 'init threads' event.
   * 
   * @param {CustomEvent} e - The event object containing the result data.
   * 
   */ #onInitThreads = (e)=>{
        const { detail: threads = [] } = e;
        $c06cac3eedeb74d1$var$_LOG('threads', threads);
        this.threadMap = new Map(threads.map((/** @type {[string, ResultData[]]} */ [thread, results])=>[
                thread,
                new (0, $ceb960a0a14a1b97$export$694e0d28c7ffc90c)(results)
            ]));
        if (threads && threads.length > 0) {
            this.selectedTab = threads[0][0];
            this.requestUpdate();
        }
    };
    /**
   * Event handler for the 'result' event.
   * 
   * @param {CustomEvent<[string, ResultData]>} e - The event object containing the result data.
   * 
   */ #onResult = (e)=>{
        const [thread, result] = e.detail;
        $c06cac3eedeb74d1$var$_LOG('ON RESULT', thread, result);
        if (!this.threadMap.has(thread)) throw new Error(`result doesn't contain a valid thread! ${thread}`);
        const stack = this.threadMap.get(thread);
        if (!stack) throw new Error(`thread "${thread} doesn't contain a valid stack! `);
        const results = stack.peek();
        const index = results ? results.push(result) : stack.push([
            result
        ]);
        if (result.cancelled) // add new elemnt into history stack
        stack.push([]);
        this.threadMap.set(thread, stack);
        if (result.next || result.node) {
            /** @typedef {CustomEvent<NextNodeData>} */ const event = new CustomEvent('graph-active', {
                detail: {
                    node: result.next ?? result.node,
                    subgraphNode: result.subgraphNode
                },
                bubbles: true,
                composed: true,
                cancelable: true
            });
            this.dispatchEvent(event);
        }
        this.requestUpdate();
        this.updateComplete.then(()=>{
            const id = `#json${index - 1}`;
            // @ts-ignore
            const elems = this.shadowRoot.querySelectorAll(id);
            $c06cac3eedeb74d1$var$_LOG(id, elems);
            for (const elem of elems)// @ts-ignore
            elem.expandAll();
        });
    };
    /**
   * Event handler select tab.
   * 
   * @param {Event} event - The event object.
   * 
   */ #onSelectTab(event) {
        // @ts-ignore
        const { id: id } = event.target;
        $c06cac3eedeb74d1$var$_LOG('onSelectTab', id);
        this.selectedTab = id;
        this.requestUpdate();
    }
    // @ts-ignore
    #onNewTab(event) {
        $c06cac3eedeb74d1$var$_LOG('NEW TAB', event);
        const threadId = `Thread-${this.threadMap.size + 1}`;
        this.threadMap.set(threadId, new (0, $ceb960a0a14a1b97$export$694e0d28c7ffc90c)());
        this.selectedTab = threadId;
        this.requestUpdate();
    }
    /**
   * 
   * @param {CustomEvent<ResultData>} e - The event object containing the result data.
   * 
   */ #onNodeUpdated(e) {
        $c06cac3eedeb74d1$var$_LOG('onNodeUpdated', e);
    }
    /**
   * 
   * @param {CustomEvent<'start'|'stop'|'interrupted'|'error'>} e 
   */ #onStateUpdated(e) {
        $c06cac3eedeb74d1$var$_LOG('onStateUpdated', e);
        if (e.detail === 'stop' && this.selectedTab) {
            // add new elemnt into history stack
            const stack = this.threadMap.get(this.selectedTab)?.push([]);
        }
    }
    /** 
   * Renders a result.
   * @param {ResultData} result - The result data to render.
   * @returns The template for the result.
   */ // @ts-ignore
    #renderResult(result, index) {
        return (0, $800sp.html)`
    <div class="collapse collapse-arrow bg-base-200">
      <input type="radio" name="item-${index}" checked="checked" />
      <div class="collapse-title text-ml font-bold">${result.cancelled ? '"CANCELLED"' : result.node}</div>
      <div class="collapse-content">
        <lg4j-node-output id="(${result.node})[${index}]" value="${JSON.stringify(result).trim()}"></lg4j-node-output>
      </div>
    </div>
    `;
    }
    #renderResults() {
        if (!this.selectedTab) return (0, $800sp.html)`<div class="alert alert-warning">No Data</div>`;
        return this.threadMap.get(this.selectedTab)?.elements.filter((results)=>results.length > 0).map((results, index)=>(0, $800sp.html)`
          <div class="collapse collapse-plus bg-neutral-500">
            <input type="radio" name="execution-${index === 0 ? '0' : '1'}" checked="${index === 0 ? 'checked' : (0, $800sp.nothing)}" />
            <div class="collapse-title text-ml font-bold">${index === 0 ? 'Last Execution' : `Execution (${index})`}</div>
            <div class="collapse-content">
              <table class="table table-pin-rows">
                <tbody>
                  ${results.map((result)=>(0, $800sp.html)`<tr><td>${this.#renderResult(result, index)}</td></tr>`)}
                </tbody>
              </table>
            </div>
          </div>`);
    }
    #renderTabs() {
        const threads = [
            ...this.threadMap.keys()
        ];
        return (0, $800sp.html)`
    ${threads.map((t)=>(0, $800sp.html)`<a id="${t}" @click="${this.#onSelectTab}" role="tab" class="tab ${this.selectedTab === t ? 'tab-active' : ''}" >${t}</a>`)}
    `;
    }
    render() {
        return (0, $800sp.html)`
      
      <div class="h-full">
        <div role="tablist" class="tabs tabs-bordered">
            ${this.#renderTabs()}
            <a role="tab" class="tab" @click="${this.#onNewTab}">
              <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <circle cx="10" cy="10" r="9" fill="none" stroke="white" stroke-width="1.5"/>
                <line x1="5" y1="10" x2="15" y2="10" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="10" y1="5" x2="10" y2="15" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </a>
          </div>
            <div class="max-h-[95%] overflow-x-auto bg-slate-500">
            ${this.#renderResults()}
            </div>
        </div> 
    `;
    }
    /** 
   * Renders a result.
   * @param {ResultData} result - The result data to render.
   * @returns The template for the result.
   * @deprecated
   */ // @ts-ignore
    #renderResultDeprecated(result, index) {
        return (0, $800sp.html)`
      <div class="collapse collapse-arrow bg-base-200">
        <input type="radio" name="item-1" checked="checked" />
        <div class="collapse-title text-ml font-bold">${result.node}</div>
        <div class="collapse-content">
        ${Object.entries(result.// @ts-ignore
        state).map(([key, value])=>(0, $800sp.html)`
            <div>
                <h4 class="italic">${key}</h4>
                <p class="my-3">
                  <json-viewer id="json${index}">
                    ${JSON.stringify(value)}
                  </json-viewer>
                </p>
              </div>
          `)}
        </div>
      </div>
      `;
    }
    // @deprecated
    // @ts-ignore
    #renderResultWithCard(result, index) {
        return (0, $800sp.html)`
    <div class="card bg-neutral text-neutral-content">
    <div class="card-body">
      <h2 class="card-title">${result.node}</h2>
      <div class="collapse collapse-arrow bg-base-200">
        <input type="radio" name="item-1" checked="checked" />
        <div class="collapse-content">
        ${Object.entries(result.state).map(([key, value])=>(0, $800sp.html)`
          <div>
              <h4 class="italic">${key}</h4>
              <p class="my-3">
                <json-viewer id="json${index}">
                ${JSON.stringify(value)}
                </json-viewer>
              </p>
            </div>
        `)}
        </div>
        </div>
    </div>
  </div>   `;
    }
}
window.customElements.define('lg4j-result', $c06cac3eedeb74d1$export$c5542a7edb16317);


//# sourceMappingURL=webui.6d198d54.js.map
